export default {
  getRefundFee (VueApp, id, callback) {
    VueApp.$sdk.get('/transaction/' + id + '/fee', {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      callback(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/transactions/refund.js